export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const FETCH_NOTIFICATIONS_SUCCEED = 'FETCH_NOTIFICATIONS_SUCCEED';
export const FETCH_NOTIFICATIONS_FAILED = 'FETCH_NOTIFICATIONS_FAILED';

export const FETCH_USER_NOTIFICATIONS = 'FETCH_USER_NOTIFICATIONS';
export const FETCH_USER_NOTIFICATIONS_SUCCEED = 'FETCH_USER_NOTIFICATIONS_SUCCEED';
export const FETCH_USER_NOTIFICATIONS_FAILED = 'FETCH_USER_NOTIFICATIONS_FAILED';

export const CHECKED_USER_NOTIFICATIONS = 'CHECKED_USER_NOTIFICATIONS';
export const CHECKED_USER_NOTIFICATIONS_SUCCEED = 'CHECKED_USER_NOTIFICATIONS_SUCCEED';
export const CHECKED_USER_NOTIFICATIONS_FAILED = 'CHECKED_USER_NOTIFICATIONS_FAILED';

export const CHECKED_ALL_USER_NOTIFICATIONS = 'CHECKED_ALL_USER_NOTIFICATIONS';
export const CHECKED_ALL_USER_NOTIFICATIONS_SUCCEED = 'CHECKED_ALL_USER_NOTIFICATIONS_SUCCEED';
export const CHECKED_ALL_USER_NOTIFICATIONS_FAILED = 'CHECKED_ALL_USER_NOTIFICATIONS_FAILED';

export const DELETE_USER_NOTIFICATIONS = 'DELETE_USER_NOTIFICATIONS';
export const DELETE_USER_NOTIFICATIONS_SUCCEED = 'DELETE_USER_NOTIFICATIONS_SUCCEED';
export const DELETE_USER_NOTIFICATIONS_FAILED = 'DELETE_USER_NOTIFICATIONS_FAILED';

export const DELETE_ALL_USER_NOTIFICATIONS = 'DELETE_ALL_USER_NOTIFICATIONS';
export const DELETE_ALL_USER_NOTIFICATIONS_SUCCEED = 'DELETE_ALL_USER_NOTIFICATIONS_SUCCEED';
export const DELETE_ALL_USER_NOTIFICATIONS_FAILED = 'DELETE_ALL_USER_NOTIFICATIONS_FAILED';

export const FETCH_MARKED_NOTIFICATIONS = 'FETCH_MARKED_NOTIFICATIONS';
export const FETCH_MARKED_NOTIFICATIONS_SUCCEED = 'FETCH_MARKED_NOTIFICATIONS_SUCCEED';
export const FETCH_MARKED_NOTIFICATIONS_FAILED = 'FETCH_MARKED_NOTIFICATIONS_FAILED';
